import { Component,Output,ViewChild, EventEmitter } from '@angular/core';

@Component({
  selector: 'export-bills',
  templateUrl: '../../templates/partials/bills-exports.html'
})
export class ExportBillsComponent{

    @ViewChild('dateFrom') dateFrom;
    @ViewChild('dateSince') dateSince;

    constructor(){}

    public closeSibiling(event){
        //console.log(event);
        if(event == "desde"){
            this.dateSince.opened = false;
        }else if(event == "hasta"){
             this.dateFrom.opened = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/exports/components/dummy/bills-exports.component.ts